(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.Shopify && window.Shopify.designMode) return;

    const initializedSections = window.vingsRandomProductSections || new Set();
    window.vingsRandomProductSections = initializedSections;

    const shuffle = (items) => {
      const shuffled = [...items];
      for (let index = shuffled.length - 1; index > 0; index -= 1) {
        const swapIndex = Math.floor(Math.random() * (index + 1));
        [shuffled[index], shuffled[swapIndex]] = [shuffled[swapIndex], shuffled[index]];
      }
      return shuffled;
    };

    document.querySelectorAll('[data-randomize-products="true"]').forEach((products) => {
      const sectionId = products.dataset.id;
      const categories = (products.dataset.randomCategoryPages || '')
        .split(',')
        .map((entry) => {
          const [handle, pages] = entry.split(':');
          return { handle, pages: Number(pages) };
        })
        .filter((category) => category.handle && Number.isInteger(category.pages) && category.pages > 0);
      const grid = products.querySelector('ul.product-grid');
      if (!sectionId || !grid || categories.length < 4 || initializedSections.has(sectionId)) return;
      initializedSections.add(sectionId);

      const selectedCategories = shuffle(categories).slice(0, 4);
      const pickPage = (category) => {
        const storageKey = `vings-random-featured-collection-${sectionId}-${category.handle}`;
        let previousPage = 0;
        try {
          previousPage = Number(window.sessionStorage.getItem(storageKey));
        } catch {}

        let page = Math.floor(Math.random() * category.pages) + 1;
        if (category.pages > 1 && page === previousPage) page = page === category.pages ? 1 : page + 1;
        try {
          window.sessionStorage.setItem(storageKey, String(page));
        } catch {}
        return page;
      };
      const fetchCards = async (category) => {
        const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const url = new URL(`${root}collections/${category.handle}`, window.location.origin);
        url.searchParams.set('section_id', 'vings-random-product-source');
        url.searchParams.set('page', String(pickPage(category)));
        const response = await fetch(url);
        if (!response.ok) return [];
        const template = document.createElement('template');
        template.innerHTML = await response.text();
        return [...template.content.querySelectorAll('li.grid__item')];
      };

      Promise.all(selectedCategories.map(fetchCards))
        .then((cardGroups) => {
          if (grid.contains(document.activeElement)) return;
          const usedProductUrls = new Set();
          const sourceCards = cardGroups.map((cards) =>
            shuffle(cards).find((card) => {
              const productUrl = card.querySelector('a[href*="/products/"]')?.href;
              if (!productUrl || usedProductUrls.has(productUrl)) return false;
              usedProductUrls.add(productUrl);
              return true;
            })
          );
          const targetCards = [...grid.children].filter((card) => card.matches('li.grid__item')).slice(0, 4);
          if (sourceCards.some((card) => !card) || targetCards.length !== sourceCards.length) return;
          targetCards.forEach((card, index) => {
            card.innerHTML = sourceCards[index].innerHTML;
          });
        })
        .catch(() => {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
